export default __webpack_public_path__ + "static/media/leh4.39e58c7f.jpg";